import { QRCodeSVG } from "qrcode.react";

type AppQrCodeProps = {
	id?: string;
	value: string;
	size?: number;
	className?: string;
};

export function AppQrCode({ id, value, size, className }: AppQrCodeProps) {
	return (
		<QRCodeSVG
			id={id}
			value={value}
			size={size}
			level="H"
			includeMargin={false}
			className={className}
			fgColor="#000000"
			bgColor="#FFFFFF"
		/>
	);
}
